// extracted by mini-css-extract-plugin
export default {"behavior":"behavior__FGOr7XfU","header":"header__csmpPJdo","title":"title__kZlK6GFw","actions":"actions__RFdnekN1","icon":"icon__NmtgsKAT","content":"content__Ez8BZFA9"};